import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from './axiosBaseQuery'
import { baseUrl } from './axiosInstance'

const advertisementApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl
  }),
  reducerPath: 'advertisementApi',
  tagTypes: ['advertisement'],
  endpoints: () => ({})
})

export default advertisementApi
